@let visibleConfigValue = visibleConfig();
@let width = windowWidth();

@if (visibleConfigValue.length > 0) {
  <div class="more-menu">
    @let cfgFirstButton = visibleConfigValue[0]!;

    @if (visibleConfigValue.length > 1 && width > 1100) {
      <fr8bot-ui-button
        type="primary"
        size="small"
        [attr.data-testid]="cfgFirstButton.testId"
        (click)="cfgFirstButton.action()"
        [disabled]="!!cfgFirstButton.disabled"
        class="more-menu__firstButton"
      >
        {{ cfgFirstButton.buttonText | translate }}
      </fr8bot-ui-button>
    }

    @if (visibleConfigValue.length === 1 && width > 1100) {
      <fr8bot-ui-button
        type="primary"
        size="small"
        [attr.data-testid]="cfgFirstButton.testId"
        (click)="cfgFirstButton.action()"
        [disabled]="!!cfgFirstButton.disabled"
        class="more-menu__firstButton"
      >
        {{ cfgFirstButton.buttonText | translate }}
      </fr8bot-ui-button>
    } @else {
      <fr8bot-ui-button
        type="secondary"
        size="small"
        data-testid="more-menu-trigger"
        [matMenuTriggerFor]="moreMenu"
      >
        <fr8bot-ui-icon name="more-16" [size]="16" />
      </fr8bot-ui-button>
    }
  </div>

  <mat-menu
    #moreMenu="matMenu"
    xPosition="before"
    class="dropdown-menu dropdown-menu--width-210"
    [overlapTrigger]="false"
  >
    @for (cfg of visibleConfigValue; track $index) {
      <button
        class="dropdown-item"
        [attr.data-testid]="cfg.testId"
        (click)="cfg.action()"
        [disabled]="cfg.disabled"
      >
        <div class="dropdown-item__text">
          <span class="dropdown-item__text-label">{{ cfg.buttonText | translate }}</span>
        </div>
      </button>
    }
  </mat-menu>
}
